export default __webpack_public_path__ + "static/media/bg-right-920.95ba3777.svg";